import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { motion } from "framer-motion"

function Contact() {

const btnVar = {

    hover: {
        scale: 1.1,
        transition: {
            type: 'spring',
            duration: .5,
            duration: .3,
            yoyo: 8,
            color: 'transparent'
        },
    },
}

    useEffect(() => {
        Aos.init({duration: 2000, offset: 400})
    }, [])

    return(
        <div data-aos='fade-down' className='contact' >
            <div>
                <h2>Let's Chat</h2>
                <p>
                I’m currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!
                </p>
                <a href='mailto:alagbadatosin@gmail.com'><motion.button
                    variants={btnVar}
                    whileHover='hover'
                >hello@tosin.dev</motion.button></a>
                
            </div>
        </div>
    )
}

// export default React.memo(Contact)
export default Contact

